import React, { useCallback, useEffect, useState } from "react";
import getUrl from "../function/getUrl";
import checkLogin from "../function/checkLogin.js";

const EventExtendRollback = () => {
  const url = getUrl();
  const token = sessionStorage.getItem("token");
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [orders, setOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  if (!checkLogin()) {
    window.location.href = "/logout";
  }

  const fetchEvents = useCallback(async () => {
    setLoading(true);
    setMessage("");
    try {
      const data = await fetch(`${url}/appGet/getEventExtendEvents?token=${token}`).then((res) => res.json());
      setEvents(data);
      setMessage(`一個月內可 rollback 的事件 ${data.length} 筆`);
    } catch (err) {
      console.error(err);
      setMessage("查詢事件失敗");
    }
    setLoading(false);
  }, [token, url]);

  const fetchOrders = async (eventItem) => {
    if (!eventItem) {
      return;
    }
    setLoading(true);
    setMessage("");
    try {
      const data = await fetch(`${url}/appGet/getEventExtendOrders?memo=${encodeURIComponent(eventItem.memo)}&token=${token}`).then((res) => res.json());
      const nextSelectedOrders = {};
      data.forEach((item) => {
        nextSelectedOrders[item.orderDBID] = true;
      });
      setSelectedEvent(eventItem);
      setOrders(data);
      setSelectedOrders(nextSelectedOrders);
      setMessage(`事件「${eventItem.eventName}」可取消訂單 ${data.length} 筆`);
    } catch (err) {
      console.error(err);
      setMessage("查詢訂單失敗");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  const selectedCount = orders.filter((item) => selectedOrders[item.orderDBID]).length;
  const allSelected = orders.length > 0 && selectedCount === orders.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedOrders({});
      return;
    }
    const nextSelectedOrders = {};
    orders.forEach((item) => {
      nextSelectedOrders[item.orderDBID] = true;
    });
    setSelectedOrders(nextSelectedOrders);
  };

  const toggleOrder = (orderDBID) => {
    setSelectedOrders((prev) => {
      return {
        ...prev,
        [orderDBID]: !prev[orderDBID],
      };
    });
  };

  const rollbackSelectedOrders = async () => {
    if (!selectedEvent) {
      alert("請先選擇事件");
      return;
    }
    const orderDBIDList = orders
      .filter((item) => selectedOrders[item.orderDBID])
      .map((item) => item.orderDBID);
    if (orderDBIDList.length === 0) {
      alert("請至少選擇一筆訂單");
      return;
    }

    const typedName = window.prompt(`即將取消「${selectedEvent.eventName}」的事件延長訂單 ${orderDBIDList.length} 筆。\n此功能只允許 rollback 一個月內事件。\n請輸入事件名稱確認：${selectedEvent.eventName}`);
    if (typedName !== selectedEvent.eventName) {
      alert("事件名稱不一致，已取消 rollback");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("token", token);
    formData.append("memo", selectedEvent.memo);
    formData.append("orderDBIDList", orderDBIDList.join(","));
    try {
      const data = await fetch(`${url}/appPost/rollbackSelectedEventExtendOrders`, {
        method: "POST",
        body: formData,
      }).then((res) => res.json());
      setMessage(`Rollback 完成：取消 ${data.rollbackCount || 0} 筆`);
      await fetchEvents();
      await fetchOrders(selectedEvent);
    } catch (err) {
      console.error(err);
      setMessage("Rollback 失敗");
    }
    setLoading(false);
  };

  return (
    <div className="container-fluid pt-3">
      {loading && (
        <div
          className="position-fixed d-flex align-items-center justify-content-center"
          style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.35)",
            zIndex: 2000,
          }}
        >
          <div className="text-center bg-white border rounded p-4">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div>系統處理中，請稍候</div>
          </div>
        </div>
      )}
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">事件延長 Rollback</h5>
          <div className="alert alert-warning">
            僅列出並允許取消一個月內建立、eventDBID 為 50 的事件延長訂單。
          </div>

          <button className="btn btn-secondary mb-3" onClick={fetchEvents} disabled={loading}>
            重新整理事件
          </button>
          {message !== "" && <div className="alert alert-info">{message}</div>}

          <div className="row">
            <div className="col-12 col-lg-5">
              <h6>事件清單</h6>
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <th>選取</th>
                    <th>事件</th>
                    <th>天數</th>
                    <th>筆數</th>
                    <th>建立日期</th>
                  </tr>
                </thead>
                <tbody>
                  {events.map((item) => {
                    const active = selectedEvent && selectedEvent.memo === item.memo;
                    return (
                      <tr key={item.memo} className={active ? "table-primary" : ""}>
                        <td>
                          <button className="btn btn-sm btn-outline-primary" onClick={() => fetchOrders(item)} disabled={loading}>
                            選取
                          </button>
                        </td>
                        <td>{item.eventName}</td>
                        <td>{item.classDays}</td>
                        <td>{item.orderCount}</td>
                        <td>{item.firstDate}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="col-12 col-lg-7">
              <div className="d-flex align-items-center mb-2">
                <h6 className="mb-0 mr-3">訂單清單</h6>
                <button className="btn btn-outline-dark btn-sm mr-2" onClick={toggleSelectAll} disabled={orders.length === 0}>
                  {allSelected ? "取消全選" : "全選"}
                </button>
                <button className="btn btn-outline-danger btn-sm mr-2" onClick={rollbackSelectedOrders} disabled={loading || selectedCount === 0}>
                  執行取消延長
                </button>
                <span>已選 {selectedCount} / {orders.length}</span>
              </div>

              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>選取</th>
                    <th>訂單</th>
                    <th>姓名</th>
                    <th>建立日期</th>
                    <th>有效期限起算</th>
                    <th>原訂單</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((item) => {
                    return (
                      <tr key={item.orderDBID}>
                        <td>
                          <input
                            type="checkbox"
                            checked={!!selectedOrders[item.orderDBID]}
                            onChange={() => toggleOrder(item.orderDBID)}
                          />
                        </td>
                        <td>{item.orderDBID}</td>
                        <td>{item.name}</td>
                        <td>{item.orderDate}</td>
                        <td>{item.classStartDate}</td>
                        <td>{item.extendFromOrderDBID}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventExtendRollback;
